<style>
	.summary-wrapper{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom:0;
		width: 100%;
		background-color: #eee;
		z-index: 100;
		overflow: scroll;
	}
	.summary-filter-shell{
		position: relative;
    padding-bottom: 1px;
		/*top: 45px;*/
		left: 0;
		right: 0;
		background: #fff;
	}
	.summary-filter-ul{
		background-color: #fff;
	}
	.summary-filter-ul li {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		height: 40px;
		line-height: 40px;
		border-bottom: solid 1px #eee;
		padding-left: 12px;
		overflow: hidden;
		background: url(../assets/listview-arrow.jpg) no-repeat 97% 50%;
		background-size: 10px 15px;
	}
	.summary-filter-ul li span{
		float: right;
		margin-right: 1.5em
	}
	.summary-filter-ul li input[type="date"]{
		width:75%;
		background: yellow;
		position: absolute;
		/*right: -34px;*/
		height: 25px;
		border: solid 1px #000;
		margin-top: 5px;
		margin-right: 1.5em;
		border: none;
		font-size: 1em;
		text-align: right;
		background: url(../assets/whitebg.png);
	}
	.summary-filter-btn{
		display: block;
		background-color: #269fa5;
		color: #fff;
		text-align: center;
		margin:1em;
		padding: .5em 1em;
		border-radius: 5px;
	}
	.stateFont {
		width: 65%;
		text-align: right;
		overflow: hidden;
    	word-break: keep-all;
    	white-space: nowrap;
    	text-overflow: ellipsis;
	}
	/* .search-tips{
		color: #666;
		font-size: 0.8em;
		text-align: center;
		margin: 0 0 1em;
		padding: 0;
	} */
</style>
<template>
<div>
	<transition name="slide">
		<div v-show="show" class="summary-wrapper">
			<a class="bill-filter-cancel" @click="show = false">取消</a>
			<navbar title="金额汇总-汇总条件筛选"></navbar>
			<div class="summary-filter-shell">
				<ul class="summary-filter-ul">
					<li @click="selectCompany">餐企名称<span><strong>{{restaurantName}}</strong></span></li>
					<li @click="onSelectOrgan">机构<span><strong>{{organName}}</strong></span></li>
					<li @click="selectBillStatus(billState, billStateFont)">单据状态 <span class="stateFont">{{billStateFont}}</span></li>
					<li @click="selectDateType">日期类型 <span>{{dateTypeFont}}</span></li>
					<li>开始日期 <input type="date" v-model="startDate"/><span></span></li>
					<li>结束日期 <input type="date" v-model="endDate"/><span></span></li>
				</ul>
				<a class="summary-filter-btn" @click="searchPost(null)">查询</a>
				<a class="summary-filter-btn" @click="searchPost(true)">查询当天订单</a>
				<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
			</div>
		</div>
	</transition>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<company-select ref="companySelectShow" v-on:selectCompany="companyStatus" :selectedId="restaurantId" :selectedName="restaurantName"></company-select>
	<organ-select ref="organSelectShow" v-on:selectedOrgan="onSelectedOrgan" :selectedName="organName" :restaurantId="restaurantId"></organ-select>
	<bill-status-select ref="billStatuselectShow" v-on:confirm="getBillStatus" :billStatusFlag="billState" :billStateFont="billStateFont" :title="billStateTitle" :statusList="GoodsSummaryBillState"></bill-status-select>
	<date-type-select ref="dateTypeShow" v-on:selectDateType="getDateType" :dateTypeFlag="dateTypeFlag" :title="dateTypeTitle"></date-type-select>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
import CompanySelect from '../components/CompanySelect'
import OrganSelect from '../components/OrganSelectM'
import BillStatusSelect from '../components/BillStatusSelectM'
import DateTypeSelect from '../components/DateTypeSelect'
import ShowTypeSelect from '../components/ShowTypeSelect'
import TipsAuto from './TipsAuto'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			tipsauto: false,
			tipsFont: '',
			sec: 1500,
			show: false,
			restaurantName: '',
			restaurantId: '',
			billState: '14,21',
			billStateFont: '',
			billStateId: '',
			dateTypeFlag: '',
			dateTypeFont: '',
			startDate: '',
			endDate: '',
			store: GlobalStore,
			billStateTitle: '货品汇总-选择单据状态',
			dateTypeTitle: '货品汇总-选择日期类型',
			organName: '全部机构',
			organId: '',
			organIds: null,
			organList: [],
			GoodsSummaryBillState: [
				{
					stateValue: 'all',
					stateFont: '全选',
					checked: false
				},
				{
					stateValue: '10',
					stateFont: '未处理',
					checked: false
				}, {
					stateValue: '11',
					stateFont: '待发货',
					checked: false
				}, {
					stateValue: '12',
					stateFont: '已发货',
					checked: false
				}, {
					stateValue: '13',
					stateFont: '已收货',
					checked: false
				}, {
					stateValue: '14,15,16,17',
					stateFont: '已收货已确认',
					checked: false
				}, {
					stateValue: '20',
					stateFont: '退货未确认',
					checked: false
				}, {
					stateValue: '21',
					stateFont: '退货已确认',
					checked: false
				}
			]
		}
	},
	components: {
		'navbar': NavBar,
		'company-select': CompanySelect,
		'organ-select': OrganSelect,
		'bill-status-select': BillStatusSelect,
		'date-type-select': DateTypeSelect,
		'show-type-select': ShowTypeSelect,
		'tips-auto': TipsAuto
	},
	created () {
		// var goodsTotalInfo = this.store.goodsTotalInfo
		// this.billState Handle()
	},
	methods: {
		getDateType (msg) {
			this.dateTypeFlag = msg
			window.console.log(this.dateTypeFlag)
			switch (msg) {
			case '0':
				this.dateTypeFont = '订货日期'
				break
			case '1':
				this.dateTypeFont = '到货日期'
				break
			case '2':
				this.dateTypeFont = '收货日期'
				break
			case '3':
				this.dateTypeFont = '入库日期'
				break
			}
		},
		getBillStatus (msg) {
			window.console.log(msg)
			this.billState = msg[0].join(',')
			this.billStateFont = msg[1].join(',')
		},
		companyStatus (msg) {
			var str = msg.split('|')
			this.restaurantId = str[0]
			this.restaurantName = str[1]
			// window.console.log(this.restaurantName + ',' + this.restaurantId)
		},
		billStateHandle () {
			// 单据状态处理函数
			switch (this.billState) {
			case '10':
				this.billStateFont = '未处理'
				break
			case '11':
				this.billStateFont = '待发货'
				break
			case '12':
				this.billStateFont = '已发货'
				break
			case '13':
				this.billStateFont = '已收货'
				break
			}
		},
		open (filterParam) {
			this.show = !this.show
			this.restaurantName = filterParam.restaurant_name
			this.restaurantId = filterParam.restaurant_id
			// this.organId = filterParam.organ_id
			this.organName = filterParam.organ_name
			this.billState = filterParam.bill_state
			this.dateTypeFlag = filterParam.sort_method
			this.startDate = filterParam.start_date
			this.endDate = filterParam.end_date
			this.initHandle()
		},
		initHandle () {
			// 餐企初始化
			if (this.restaurantName === undefined) {
				this.restaurantName = '请选择餐企'
				this.restaurantId = ''
			}
			// 日期类型初始化
			switch (this.dateTypeFlag) {
			case undefined:
				this.dateTypeFlag = '0'
				this.dateTypeFont = '订货日期'
				break
			case '0':
				this.dateTypeFont = '订货日期'
				break
			case '1':
				this.dateTypeFont = '到货日期'
				break
			}
			// 单据状态初始化
			var stateFont = []
			this.GoodsSummaryBillState.forEach(item => {
				var index = this.billState.indexOf(item.stateValue.split(',')[0])
				if (index !== -1 && item.stateValue !== 'all') {
					stateFont.push(item.stateFont)
				}
			})
			this.billStateFont = stateFont.join(',')
			let statusNotAll = this.GoodsSummaryBillState.filter(item => {
				return item.stateValue !== 'all'
			})
			var stateNotAll = []
			statusNotAll.forEach(x => {
				x.stateValue.split(',').forEach(y => {
					stateNotAll.push(y)
				})
			})
			if (stateNotAll.length === this.billState.split(',').length) {
				this.billStateFont = '全选'
			}
			// 开始日期初始化
			if (this.startDate === undefined) {
				var d = new Date()
				var month = d.getMonth()
				month < 10 ? (month = '0' + (month + 1)) : month = d.getMonth() + 1
				this.startDate = d.getFullYear() + '-' + month + '-' + d.getDate()
				// window.console.log(this.startDate)
				this.endDate = d.getFullYear() + '-' + month + '-' + d.getDate()
			}
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		searchPost (todayFlag) {
			this.getSearchCondition(todayFlag).then(searchCondition => {
				this.show = false
				this.$emit('searchPost', searchCondition)
			})
		},
		getSearchCondition (todayFlag) {
			return new Promise((resolve, reject) => {
				if (this.restaurantId === '') {
					var self = this
					self.tipsauto = true
					self.tipsFont = '餐企名称不能为空'
					setTimeout(() => {
						self.tipsauto = false
					}, self.sec)
					return reject()
				}
				if (this.billState.length === 0) {
					this.autoTips('请至少选择一种单据状态')
					return reject()
				}
				if (!this.organIds.length) {
					this.autoTips('请至少选择一个机构')
					return reject()
				}

				var currentDate = this.$fxUtils.setDate(this.$fxUtils.getCustomDate(0))
				var searchCondition = {
					bill_state: todayFlag ? '10,11,12,13,14,20,21' : this.billState,
					restaurant_id: this.restaurantId,
					restaurant_name: this.restaurantName,
					organIds: this.organIds,
					organ_name: todayFlag ? '全部机构' : this.organName,
					sort_method: todayFlag ? '0' : this.dateTypeFlag,
					start_date: todayFlag ? currentDate : this.startDate,
					end_date: todayFlag ? currentDate : this.endDate
				}
				resolve(searchCondition)
			})
		},
		selectCompany () {
			this.organName = '全部机构'
			this.$refs.companySelectShow.open()
		},
		selectBillStatus (flag, font) {
			this.$refs.billStatuselectShow.open(flag, font)
		},
		selectDateType () {
			this.$refs.dateTypeShow.open('true')
		},
		onSelectOrgan () {
			console.log(this.organIds)
			this.$refs.organSelectShow.open(this.organList, this.organIds)
		},
		onSelectedOrgan (selOrganIds) {
			const firstOrganId = selOrganIds[0]
			this.organIds = selOrganIds
			this.organName = ''
			this.organList.forEach(item => {
				if (item.organId === firstOrganId) {
					this.organName = item.name
					return
				}
			})

			if (selOrganIds.length === this.organList.length) {
				this.organName = '全部机构'
			} else if (selOrganIds.length > 1) {
				this.organName = this.organName + ' 等'
			}
		}
	},
	watch: {
		restaurantId (newValue, oldValue) {
			this.$http.get('/cldEdi/business/getShopList.do?restraurantId=' + newValue,
				{}
			).then((response) => {
				this.organList = response.body.data
				// this.organId = ''
				this.organName = '全部机构'

				// default value
				this.organIds = []
				this.organList.forEach(item => {
					this.organIds.push(item.organId)
				})
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// MoneySummaryFilter.vue?58415240